import SectionCard from '../../components/ui/SectionCard'
import ExchangeRateHealthBadge from './ExchangeRateHealthBadge'
import { ui } from '../../styles/ui'

function textOrFallback(value, fallback = '—') {
  if (value === undefined || value === null || value === '') return fallback
  return String(value)
}

function OverviewStat({ label, value }) {
  return (
    <div className="rounded-lg border border-outline bg-surface-elevated p-3">
      <div className="text-xs uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className="mt-1 text-lg font-semibold text-foreground">{textOrFallback(value)}</div>
    </div>
  )
}

function formatDateTime(value) {
  if (!value) return 'Not scheduled yet'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString()
}

function AutoSyncBadge({ status }) {
  const enabled = Boolean(status?.enabled)
  const style = enabled ? ui.badges.success : ui.badges.neutral
  return <span className={`${ui.badges.base} ${style}`}>{enabled ? 'Enabled' : 'Disabled'}</span>
}

export default function ExchangeRatesOverview({ summary, autoSyncStatus }) {
  const safeSummary = summary || {}
  const safeAutoSyncStatus = autoSyncStatus || {}

  return (
    <SectionCard title="Overview" subtitle="Exchange-rate availability and health summary">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        <OverviewStat label="Last successful sync" value={safeSummary.lastSuccessfulSyncAt || 'Not synced yet'} />
        <OverviewStat label="Last sync attempt" value={safeSummary.lastAttemptAt || 'Not synced yet'} />
        <OverviewStat
          label="Auto sync"
          value={safeAutoSyncStatus.enabled === undefined ? 'Loading...' : safeAutoSyncStatus.enabled ? 'Enabled' : 'Disabled'}
        />
        <OverviewStat label="Next auto sync" value={formatDateTime(safeAutoSyncStatus.nextRunAt)} />
        <OverviewStat label="Fresh pairs" value={safeSummary.freshPairs} />
        <OverviewStat label="Stale pairs" value={safeSummary.stalePairs} />
        <OverviewStat label="Missing pairs" value={safeSummary.missingPairs} />
        <OverviewStat label="Failed providers" value={safeSummary.failedProviders} />
        <OverviewStat label="Total tracked pairs" value={safeSummary.totalPairs} />
        <OverviewStat label="Most recent rate date" value={safeSummary.mostRecentRateDate || 'Unknown'} />
        <OverviewStat label="Oldest rate date" value={safeSummary.oldestRateDate || 'Unknown'} />
        <OverviewStat label="Default base currency" value={safeSummary.defaultBaseCurrency || 'Unknown'} />
      </div>

      <div className="mt-4 rounded-lg border border-outline bg-surface p-3">
        <div className="text-xs uppercase tracking-wide text-muted-foreground">Dashboard conversion health</div>
        <div className="mt-2">
          <ExchangeRateHealthBadge
            health={String(safeSummary.dashboardConversionHealth || 'Unknown').toLowerCase()}
            label={safeSummary.dashboardConversionHealth || 'Unknown'}
          />
        </div>
        {safeAutoSyncStatus.enabled !== undefined ? (
          <div className="mt-3 flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
            <span>Auto sync status:</span>
            <AutoSyncBadge status={safeAutoSyncStatus} />
            <span>Last run: {formatDateTime(safeAutoSyncStatus.lastRunFinishedAt)}</span>
            <span>Base: {safeAutoSyncStatus.baseCurrency || 'EUR'}</span>
          </div>
        ) : null}
      </div>
    </SectionCard>
  )
}
